"use strict";
/**
 * Check the length of the description.
 * @param {Paper} paper The paper object containing the description.
 * @returns {number} The length of the description.
 */

module.exports = function (paper) {
  return paper.getDescription().length;
};
//# sourceMappingURL=metaDescriptionLength.js.map
//# sourceMappingURL=metaDescriptionLength.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/yoastseo/js/researches/metaDescriptionLength.js
// module id = 390
// module chunks = 0